/**
 * Ship Facilities carousel — cycle through facility items within each tab/accordion.
 * Sets a min-height on the carousel to prevent layout shift when switching slides.
 */
(function () {
  function initCarousel(carousel) {
    var slides = carousel.querySelectorAll('.facility-carousel__slide');
    var counter = carousel.querySelector('.facility-carousel__current');
    var prevBtn = carousel.querySelector('.facility-carousel__arrow.-prev');
    var nextBtn = carousel.querySelector('.facility-carousel__arrow.-next');
    var total = slides.length;
    var current = 0;

    if (!total || total < 2 || !prevBtn || !nextBtn) return;

    // Measure all slides to set a stable min-height
    function setMinHeight() {
      carousel.style.minHeight = '';
      var max = 0;
      slides.forEach(function (s) {
        s.style.display = '';
        s.classList.add('active');
      });
      slides.forEach(function (s) {
        var h = s.offsetHeight;
        if (h > max) max = h;
      });
      slides.forEach(function (s, i) {
        if (i !== current) {
          s.classList.remove('active');
        }
      });
      // Add space for the nav bar (~60px)
      var nav = carousel.querySelector('.facility-carousel__nav');
      var navH = nav ? nav.offsetHeight : 0;
      carousel.style.minHeight = (max + navH + 24) + 'px';
    }

    function show(index) {
      slides.forEach(function (s) { s.classList.remove('active'); });
      slides[index].classList.add('active');
      if (counter) counter.textContent = index + 1;
      current = index;
    }

    prevBtn.addEventListener('click', function () {
      show(current > 0 ? current - 1 : total - 1);
    });

    nextBtn.addEventListener('click', function () {
      show(current < total - 1 ? current + 1 : 0);
    });

    // Run once images have loaded for accurate measurement
    var images = carousel.querySelectorAll('img');
    var loaded = 0;
    var totalImages = images.length;

    if (totalImages === 0) {
      setMinHeight();
    } else {
      images.forEach(function (img) {
        if (img.complete) {
          loaded++;
          if (loaded === totalImages) setMinHeight();
        } else {
          img.addEventListener('load', function () {
            loaded++;
            if (loaded === totalImages) setMinHeight();
          });
          img.addEventListener('error', function () {
            loaded++;
            if (loaded === totalImages) setMinHeight();
          });
        }
      });
      // Fallback: set min-height after 2s even if images haven't loaded
      setTimeout(setMinHeight, 2000);
    }
  }

  document.querySelectorAll('.facility-carousel').forEach(initCarousel);
})();
